import "./index.css";
import { createBrowserRouter, RouterProvider } from "react-router";
import { TooltipProvider } from "@repo/ui";
import { SuperAdminGuard } from "./components/SuperAdminGuard";
import { LoginPage } from "@repo/auth";
import { OrgsDashboard } from "./routes/dashboard/OrgsDashboard";
import { OrganisationForm } from "./routes/organisations/OrganisationForm";
import { UserModifier } from "./routes/users/UserModifier";
import { CorbeilleOrganisation } from "./routes/organisations/CorbeilleOrganisation";
import { CreditsOrganisation } from "./routes/organisations/CreditsOrganisation";
import { GroupesList } from "./routes/groupes/GroupesList";
import { GroupeForm } from "./routes/groupes/GroupeForm";
import { UsersList } from "./routes/users/UsersList";
import { UserForm } from "./routes/users/UserForm";
import { ParcoursDetailAdmin } from "./routes/parcours/ParcoursDetailAdmin";
import { CampagneDetailAdmin } from "./routes/campagnes/CampagneDetailAdmin";
import { CampagneModifierAdmin } from "./routes/campagnes/CampagneModifierAdmin";
import { CampagnesOrganisation } from "./routes/organisations/CampagnesOrganisation";
import { CampagneCreerAdmin } from "./routes/organisations/CampagneCreerAdmin";
import { EvaluateursCampagne } from "./routes/campagnes/EvaluateursCampagne";
import { HorsCampagne } from "./routes/organisations/HorsCampagne";
import { ParcoursEvaluateurDetailAdmin } from "./routes/evaluateurs/ParcoursEvaluateurDetailAdmin";
import { EvaluationResults } from "./components/EvaluationResults";
import {
  ModelesScorecards,
  ScorecardEditionAdmin,
  ScorecardHistoriqueAdmin,
  ScorecardsOrganisation,
} from "./routes/scorecards/ScorecardsAdmin";
import { Parametres } from "./routes/parametres/Parametres";

const router = createBrowserRouter([
  { path: "/login", element: <LoginPage title="Corail RH Admin" /> },
  {
    element: <SuperAdminGuard />,
    children: [
      { path: "/", element: <OrgsDashboard /> },
      { path: "/organisations/creer", element: <OrganisationForm /> },
      { path: "/organisations/:id/modifier", element: <OrganisationForm /> },
      { path: "/organisations/:id/groupes", element: <GroupesList /> },
      { path: "/organisations/:id/groupes/creer", element: <GroupeForm /> },
      { path: "/organisations/:id/groupes/:groupId/modifier", element: <GroupeForm /> },
      { path: "/organisations/:id/users", element: <UsersList /> },
      { path: "/organisations/:id/users/creer", element: <UserForm /> },
      { path: "/organisations/:id/users/:userId/modifier", element: <UserModifier /> },
      { path: "/organisations/:id/credits", element: <CreditsOrganisation /> },
      { path: "/organisations/:id/corbeille", element: <CorbeilleOrganisation /> },
      // Scorecards : modèles globaux, et copies propres à chaque organisation.
      { path: "/scorecards", element: <ModelesScorecards /> },
      { path: "/scorecards/:id", element: <ScorecardEditionAdmin /> },
      { path: "/scorecards/:id/historique", element: <ScorecardHistoriqueAdmin /> },
      { path: "/organisations/:orgId/scorecards", element: <ScorecardsOrganisation /> },
      { path: "/organisations/:orgId/scorecards/:id", element: <ScorecardEditionAdmin /> },
      { path: "/organisations/:orgId/scorecards/:id/historique", element: <ScorecardHistoriqueAdmin /> },
      // Navigation hiérarchique (plan du 2026-08-26) : organisation → campagne
      // → parcours candidats ou évaluateurs.
      { path: "/organisations/:orgId/campagnes", element: <CampagnesOrganisation /> },
      { path: "/organisations/:orgId/campagnes/creer", element: <CampagneCreerAdmin /> },
      { path: "/organisations/:orgId/hors-campagne", element: <HorsCampagne /> },
      { path: "/sans-organisation/campagnes", element: <CampagnesOrganisation /> },
      { path: "/sans-organisation/hors-campagne", element: <HorsCampagne /> },
      { path: "/campagnes/:id/evaluateurs", element: <EvaluateursCampagne /> },
      { path: "/parcours/:id", element: <ParcoursDetailAdmin /> },
      { path: "/campagnes/:id", element: <CampagneDetailAdmin /> },
      { path: "/campagnes/:id/modifier", element: <CampagneModifierAdmin /> },
      { path: "/notations/:id", element: <ParcoursEvaluateurDetailAdmin /> },
      { path: "/evaluations/:evaluationId", element: <EvaluationResults /> },
      { path: "/parametres", element: <Parametres /> },
    ],
  },
  { path: "*", element: <div className="p-8 text-center text-muted-foreground">Page introuvable</div> },
]);

export function App() {
  return (
    <TooltipProvider>
      <RouterProvider router={router} />
    </TooltipProvider>
  );
}
